import Confirm from 'components/confirm';
var {MODAL_PREFIX} = require('../../constants.js');
var React = require('react');

class DeleteUser extends React.Component {

  /**
   * @params props.organization
   * @params props.user
   */
  constructor(props) {
    super(props);
  }

  render() {
    var ownerUrl = Routes.delete_organization_user_path(
      this.props.organization,
      this.props.user
    );
    return (
      <a href={ownerUrl} style={{display: "inline"}}>
        Delete User
      </a>
    );
  }
}

module.exports = DeleteUser;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/organizations/delete_user.jsx